const RECENT_WINDOW_MS = 15_000

/** A short-lived optimization hint, never proof that a session is authorized. */
export function createBrowserRefreshReceipt(options: {
  read(): string | null
  write(value: string): void
  now(): number
}) {
  return {
    isRecent(owner: string, newerThan?: number) {
      try {
        const raw = options.read()
        if (!raw || raw.length > 2048) return false
        const receipt = JSON.parse(raw)
        const now = options.now()
        return (
          receipt?.version === 1 &&
          receipt.owner === owner &&
          Number.isSafeInteger(receipt.at) &&
          receipt.at > 0 &&
          receipt.at <= now &&
          (newerThan === undefined || receipt.at > newerThan) &&
          now - receipt.at < RECENT_WINDOW_MS
        )
      } catch {
        return false
      }
    },
    mark(owner: string) {
      try {
        options.write(JSON.stringify({ version: 1, owner, at: options.now() }))
      } catch {
        // Storage denial disables cross-tab reuse; the current refresh still succeeds.
      }
    },
  }
}
